import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import EditorialModuleArticles from './EditorialModuleArticles';

import { EditorialModule_editorialArticles } from './__generated__/EditorialModule_editorialArticles.graphql';

type Props = {
    editorialArticles: EditorialModule_editorialArticles;
};

const EditorialModuleComponent: FC<Props> = ({ editorialArticles }) => {
    const articles = editorialArticles?.articles || [];
    if (!articles.length) {
        return null;
    }
    return <EditorialModuleArticles articles={articles} />;
};

export const EditorialModule = createFragmentContainer(EditorialModuleComponent, {
    editorialArticles: graphql`
        fragment EditorialModule_editorialArticles on WordpressArticlesType {
            articles {
                ...EditorialModuleArticles_articles
            }
        }
    `,
});
